// src/services/tenantService.ts
import api from './api';
import { Tenant, CreateTenantRequest, UpdateTenantRequest } from '../types';

export const tenantService = {
  getAll: () => api.get<Tenant[]>('/tenants'),
  getById: (id: number) => api.get<Tenant>(`/tenants/${id}`),
  create: (data: CreateTenantRequest) => api.post<Tenant>('/tenants', data),
  update: (id: number, data: UpdateTenantRequest) => api.put<Tenant>(`/tenants/${id}`, data),
};
